import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "./Page1_Scheduler.css";
import Select from "react-select";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";

function Page1_Scheduler({
  next,
  setSelectedDate,
  selectedDate,
  setTimeSlot,
  timeSlot,
}) {
  const options = [
    { value: "10:00 AM - 10:30 AM", label: "10:00 AM - 10:30 AM" },
    { value: "10:30 AM - 11:00 AM", label: "10:30 AM - 11:00 AM" },
    { value: "11:00 AM - 11:30 AM", label: "11:00 AM - 11:30 AM" },
    { value: "11:30 AM - 12:00 PM", label: "11:30 AM - 12:00 PM" },
    { value: "12:00 PM - 12:30 PM", label: "12:00 PM - 12:30 PM" },
    { value: "12:30 PM - 01:00 PM", label: "12:30 PM - 01:00 PM" },
    { value: "01:00 PM - 01:30 PM", label: "01:00 PM - 01:30 PM" },
    { value: "01:30 PM - 02:00 PM", label: "01:30 PM - 02:00 PM" },
    { value: "02:00 PM - 02:30 PM", label: "02:00 PM - 02:30 PM" },
    { value: "02:30 PM - 03:00 PM", label: "02:30 PM - 03:00 PM" },
    { value: "03:00 PM - 03:30 PM", label: "03:00 PM - 03:30 PM" },
    { value: "03:30 PM - 04:00 PM", label: "03:30 PM - 04:00 PM" },
    { value: "04:00 PM - 04:30 PM", label: "04:00 PM - 04:30 PM" },
    { value: "04:30 PM - 05:00 PM", label: "04:30 PM - 05:00 PM" },
    { value: "05:00 PM - 05:30 PM", label: "05:00 PM - 05:30 PM" },
    { value: "05:30 PM - 06:00 PM", label: "05:30 PM - 06:00 PM" },
  ];

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();


  console.log(timeSlot,"timeSlot timeSlot");
  
  const onSubmit = (data) => {
    setSelectedDate(data.date);
    setTimeSlot(data.timeSlot);
    console.log("Submitted Data:", data);
    next();
    // data.timeSlot => selected time slot value
    // data.date => selected date
  };

  return (
    <section className="Page1_Scheduler">
      <Row className="justify-content-center">
        {/* LEFT SIDE */}
        <div className="  col-lg-7 col-md-12  col-12  order-lg-1  order-md-2 order-2">
          <div className="p1_left">
            <div className="p1_back">
              <Link to="/registration-done">
                <FontAwesomeIcon icon={faAngleLeft} className="me-3" /> Back
              </Link>
            </div>

            <h2 className="p1_title">Appointment Scheduler</h2>
            <div className="form_holder">
              <Row className="mt-4">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Select Time Slot{" "}
                      <span className="text-danger">(*30 Mins)</span>
                    </Form.Label>

                    <Select
                      options={options}
                      placeholder="Select Time"
                      onChange={(selected) => {
                        setValue("timeSlot", selected.value, {
                          shouldValidate: true,
                        });
                      }}
                    />

                    {/* Hidden input for validation */}
                    <input
                      type="hidden"
                      {...register("timeSlot", {
                        required: "Time Slot is required",
                      })}
                    />

                    {errors.timeSlot && (
                      <p className="error_text">{errors.timeSlot.message}</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Select Date</Form.Label>

                    <Form.Control
                      type="date"
                      {...register("date", { required: "Date is required" })}
                    />

                    {errors.date && (
                      <p className="error_text">{errors.date.message}</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>

            <Button
              className="p1_next_btn mt-3"
              onClick={handleSubmit(onSubmit)}
            >
              Next
            </Button>

            <div className="p1_rules_box mt-4">
              <h5>
                {" "}
                <div className="heading_icon_holder">
                  <img
                    src="/assets/images/appoinment/attention.png"
                    className="icon_holder"
                  />
                </div>{" "}
                Some basic rules for the meeting
              </h5>
              <ul>
                <li>
                  <div className="list_icon_holder">
                    <img
                      src="assets/images/appoinment/check.png"
                      className="icon_holder"
                    />
                  </div>
                  Keep your face cam on during the discussion
                </li>
                <li>
                  {" "}
                  <div className="list_icon_holder">
                    <img
                      src="assets/images/appoinment/check.png"
                      className="icon_holder"
                    />
                  </div>
                  Sit in a quiet place (without distraction)
                </li>
                <li>
                  {" "}
                  <div className="list_icon_holder">
                    <img
                      src="assets/images/appoinment/check.png"
                      className="icon_holder"
                    />
                  </div>
                  Consider joining with a Laptop / Desktop
                </li>
              </ul>
            </div>

            <div className="p1_benefits mt-4">
              <h5>
                {" "}
                <div className="heading_icon_holder">
                  <img
                    src="/assets/images/appoinment/gift.png"
                    className="icon_holder"
                  />
                </div>{" "}
                With what you will be benefited?
              </h5>
              <ul>
                <li>In-depth analysis of your institute's marketing needs</li>
                <li>Tailored strategies for increased revenue</li>
                <li>Expert advice on leveraging digital marketing</li>
                <li>Actionable steps to enhance your institute's admissions</li>
              </ul>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE ILLUSTRATION */}
        <div className="  col-lg-5 col-md-6 col-sm-6  order-lg-2  order-md-1 order-1 ">
          <div className="p1_right text-center">
            <div className="img_holder">
              <img
                src="/assets/images/appoinment/right_img_1.png"
                alt="calendar"
                className="banner_img"
              />
            </div>
          </div>
        </div>
      </Row>
    </section>
  );
}

export default Page1_Scheduler;
